import { useEffect, useState } from 'react'

const defaultSettings = {
    enableHighAccuracy: false,
    timeout: Infinity,
    maximumAge: 0,
}

/**
 * Use position
 * {@see https://github.com/trekhleb/use-position/blob/master/src/usePosition.js}
 * @param {boolean} watch watch
 * @param {PositionOptions} userSettings userSettings
 * @returns {{latitude: number, longitude: number, error: string|null}} Position
 */
const usePosition = (watch = false, userSettings = {}) => {
    const settings = {
        ...defaultSettings,
        ...userSettings,
    }

    const [position, setPosition] = useState({})
    const [error, setError] = useState(null)

    const onChange = ({ coords, timestamp }) => {
        setPosition({
            latitude: coords.latitude,
            longitude: coords.longitude,
            accuracy: coords.accuracy,
            speed: coords.speed,
            heading: coords.heading,
            timestamp,
        })
    }

    /** @param {any} err Error */
    const onError = err => {
        setError(err.message)
    }

    useEffect(() => {
        if (!navigator || !navigator.geolocation) {
            setError('Geolocation is not supported')
            return
        }

        if (watch) {
            const watcher = navigator.geolocation.watchPosition(onChange, onError, settings)
            // eslint-disable-next-line consistent-return
            return () => navigator.geolocation.clearWatch(watcher)
        }

        navigator.geolocation.getCurrentPosition(onChange, onError, settings)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        settings.enableHighAccuracy,
        settings.timeout,
        settings.maximumAge,
    ])

    return {
        latitude: 0,
        longitude: 0,
        ...position,
        error,
    }
}

export default usePosition
